import PropTypes from 'prop-types';
import React from 'react';
import {
  ENROLL_SMS,
  REPORT_ISSUE,
  SCHEDULE_CALLBACK,
} from 'src/pages/scheduleCallback/constants/flows';
import {a11yHidden} from 'src/styles/modules/a11y.module.scss';
import {
  button,
  buttonGroup,
  primary,
} from 'src/styles/modules/button.module.scss';
import {input} from 'src/styles/modules/forms.module.scss';
import {header} from '../header.module.scss';
import {
  activeIntent,
  fieldset,
  intentBox,
  intentDescription,
  intentText,
  intentTitle,
} from './style.module.scss';

export const SelectIntentView = ({
  availableIntents,
  flow,
  onCancel,
  onChange,
  onContinue,
  selectedIntent,
}) => {
  return (
    <>
      {
        (!flow || flow === SCHEDULE_CALLBACK)
        && (
          <header className={header}>
            <h1>Tell us a little about your issue &amp; we&apos;ll get you to the right place.</h1>
            <p>Choose a topic below.</p>
          </header>
        )
      }
      {
        flow === REPORT_ISSUE
        && (
          <header className={header}>
            <h1>Sorry you&apos;re having trouble. We&apos;ll give you a call to resolve this issue.</h1>
            <p>We&apos;ve found these contact details on your account.</p>
          </header>
        )
      }
      {
        flow === ENROLL_SMS
        && (
          <header className={header}>
            <h1>It looks like something went wrong on our end</h1>
            <p>Text message notifications are currently unavailable, but we can give you a call to discuss the issue.</p>
          </header>
        )
      }
      <form>
        <fieldset className={fieldset}>
          <legend className={a11yHidden}>Call me about</legend>
          {
            availableIntents.map(({title, value, description}) => (
              <label key={title} className={`${intentBox} ${selectedIntent === value ? activeIntent : ''}`} htmlFor={value}>
                <input
                  checked={selectedIntent === value}
                  className={input}
                  id={value}
                  name="intent-radio"
                  onChange={() => onChange(value)}
                  type="radio"
                  value={value}
                />
                <span className={intentText}>
                  <span className={intentTitle}>{title}</span>
                  <span className={intentDescription}>{description}</span>
                </span>
              </label>
            ))
          }
        </fieldset>
        <div className={buttonGroup}>
          <button className={`${button} ${primary}`} onClick={onContinue} disabled={!selectedIntent} type="button">Continue</button>
          <button className={button} onClick={onCancel} type="button">Cancel</button>
        </div>
      </form>
    </>
  );
};

SelectIntentView.propTypes = {
  availableIntents: PropTypes.array.isRequired,
  flow: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  selectedIntent: PropTypes.string.isRequired,
};
